import { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./DocsSidebar.scss";

const DocsSidebar = ({ currentPath }) => {
  const [docStructure, setDocStructure] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocStructure = async () => {
      try {
        // Try to fetch sidebar.json from public/docs
        const response = await fetch("/documentation/sidebar.json");

        if (response.ok) {
          const structure = await response.json();
          setDocStructure(structure);
        } else {
          // Use default structure if sidebar.json doesn't exist
          const defaultStructure = [
            {
              title: "Getting Started",
              items: [
                { title: "Introduction", path: "getting-started" },
                { title: "Installation", path: "installation" },
              ],
            },
            {
              title: "Features",
              items: [
                { title: "Bookmarks", path: "bookmarks" },
                { title: "Collections", path: "collections" },
                { title: "Search", path: "search" },
                { title: "Spaces", path: "spaces" },
                { title: "Encryption", path: "encryption" },
              ],
            },
            {
              title: "Account",
              items: [
                { title: "Settings", path: "settings" },
                { title: "Subscription", path: "subscription" },
              ],
            },
          ];

          setDocStructure(defaultStructure);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error loading sidebar:", error);
        setLoading(false);
      }
    };

    fetchDocStructure();
  }, []);

  const isActive = (path) => {
    return currentPath === path;
  };

  if (loading) {
    return <div className="docs-sidebar">Loading...</div>;
  }

  return (
    <div className="sticky-top pt-3">
      <Nav className="flex-column bg-light rounded-4 px-4 py-3">
        {docStructure.map((section, sectionIndex) => (
          <div key={sectionIndex} className="sidebar-section">
            <div className="section-title h5 mt-3 mb-2">{section.title}</div>
            <Nav className="flex-column">
              {section.items.map((item, itemIndex) => (
                <Nav.Item key={itemIndex}>
                  <Nav.Link
                    as={Link}
                    to={`/docs/${item.path}`}
                    className={
                      isActive(item.path)
                        ? "bg-white rounded-3 fw-semibold"
                        : ""
                    }
                  >
                    {item.icon && <i className={`bi bi-${item.icon} me-2`}></i>}
                    {item.title}
                    {item.badge && (
                      <span className="badge bg-primary ms-2">
                        {item.badge}
                      </span>
                    )}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
        ))}
      </Nav>
    </div>
  );
};

export default DocsSidebar;
